import { Component, Input } from '@angular/core';
import { Router } from "@angular/router";
import { NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WebsocketService } from '../../services/websocket.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-input-card',
  templateUrl: './input-card.component.html',
  styleUrls: ['./input-card.component.scss'],
  standalone: true,
  imports: [TranslatePipe, NgIf, FormsModule]
})
export class InputCardComponent {
  @Input() input: any;
  @Input() mac: any;

  editingCounter = false;
  counterInput: number | null = null;

  constructor(private router: Router, private websocketService: WebsocketService) {}

  onEdit(): void {
    this.router.navigate(['/input-edit', this.input.eid], { state: { fromTab: 'inputs', controllerMac: this.mac } });
  }

  /** How much one pulse is worth, in the input's own unit (water meters: 0.01 m³ = 10 L). */
  private get perPulse(): number {
    const v = Number(this.input?.pulseValue);
    return Number.isFinite(v) && v > 0 ? v : 1;
  }

  get unit(): string {
    return this.input?.unit || '';
  }

  /** The reading a human wants to see: pulses scaled into the configured unit. */
  get counterText(): string {
    const pulses = this.input?.counterValue;
    if (pulses === undefined || pulses === null) return '–';

    const value = pulses * this.perPulse;
    // Show as many decimals as the pulse size actually carries — 0.01 m³ per pulse means
    // two decimals are meaningful and a third would be noise.
    const decimals = this.perPulse < 1 ? Math.min(4, String(this.perPulse).split('.')[1]?.length ?? 0) : 0;
    return `${value.toFixed(decimals)}${this.unit ? ' ' + this.unit : ''}`;
  }

  startEdit(): void {
    if (this.input?.type !== 'Counter') return;
    const pulses = this.input?.counterValue ?? 0;
    this.counterInput = pulses * this.perPulse;
    this.editingCounter = true;
  }

  // The user types the reading printed on the physical meter; the controller counts pulses,
  // so convert back before sending.
  saveCounter(): void {
    if (this.counterInput === null || !Number.isFinite(Number(this.counterInput))) {
      this.editingCounter = false;
      return;
    }
    const pulses = Math.round(Number(this.counterInput) / this.perPulse);
    this.websocketService.sendMessage({
      type: 'COMMAND',
      payload: {
        mac: this.mac,
        command: 'SETCOUNTER',
        counterId: this.input.id,
        counterValue: pulses,
      },
    });
    this.input.counterValue = pulses;   // optimistic; the device confirms with a COUNTERS message
    this.editingCounter = false;
  }

  cancelCounter(): void {
    this.editingCounter = false;
  }
}
